import Header from "src/components/templates/header";
import { AuthPage, Body, Container } from "src/theme/Styled";


const SingleLayout = ({children}) => {
  return <Body>
    <Header.Guest />
    <AuthPage className="single">
      <Container className="page">
        {children}
      </Container>
    </AuthPage>
  </Body>
};

export default SingleLayout;